
export const Inputs = [
    [
        {
            type: "text",
            label: { ar: "", en: "" },
            placeholder: { ar: "الاسم", en: "name" },
            title: { ar: "", en: "" },
            name: "name",
            size: { lg: "6", md: "6" }
        },
        {
            type: "email",
            name: "email",
            title: { ar: "", en: "" },
            label: { ar: "", en: "" },
            placeholder: { ar: "البريد الالكتروني", en: "Email" },
            size: { lg: "6", md: "6" }
        },
        {
            type: "password",
            label: { ar: "", en: "" },
            placeholder: { ar: "كلمة المرور", en: "Password" },
            title: { ar: "كلمة المرور", en: "Password" },
            name: "password",
            size: { lg: "6", md: "6" }
        },
        {
            type: "password",
            label: { ar: "", en: "" },
            placeholder: { ar: "تأكيد كلمة المرور", en: "Password confirmation" },
            title: { ar: "تأكيد كلمة المرور", en: "Password confirmation" },
            name: "confirmpassword",
            size: { lg: "6", md: "6" }
        },
        {
            type: "phone",
            label: { ar: "", en: "" },
            placeholder:  { ar: "رقم الهاتف", en: "Phone number" } ,
            title: { ar: "", en: "" },
            name: "phone",
            size: { lg: "6", md: "6" }
        },
       
    ]

];

